import api from "../api";

/**
 * postEditClubName
 *
 * ویرایش نام یک کلاب پذیرنده.
 *
 * @param data داده‌های مربوط به کلاب برای ویرایش
 * @returns Promise<any>
 */
export const postEditClubName = async (data: any) => {
  const response = await api.post(`20card/api/pazirande/edit-club`, data);
  return response.data;
};

/**
 * postAddUser
 *
 * افزودن یک کاربر جدید به پذیرنده.
 *
 * @param data اطلاعات کاربر جدید
 * @returns Promise<any>
 */
export const postAddUser = async (data: any) => {
  const response = await api.post(`20card/api/pazirande/add-user`, data);
  return response.data;
};

/**
 * postIncreaseAllBalance
 *
 * افزایش موجودی کلیه کاربران پذیرنده.
 *
 * @param data اطلاعات تراکنش افزایش موجودی
 * @returns Promise<any>
 */
export const postIncreaseAllBalance = async (data: any) => {
  const response = await api.post(
    `/20card/api/pazirande/increase-all-balance`,
    data
  );
  return response.data;
};

export const postIncreaseBalance = async (data: any) => {
  const response = await api.post(
    `/20card/api/pazirande/increase-balance`,
    data
  );
  return response.data;
};

export const postDecreaseBalance = async (data: any) => {
  const response = await api.post(
    `/20card/api/pazirande/decrease-balance`,
    data
  );
  return response.data;
};

/**
 * fetchChartMerchantName
 *
 * دریافت داده‌های نموداری مربوط به نام‌های تجاری.
 *
 * @param data اطلاعات فیلتر نمودار
 * @returns Promise<any>
 */
export const fetchChartMerchantName = async (data: any) => {
  const response = await api.post(
    `/20card/api/pazirande/chart-merchant-name`,
    data
  );
  return response.data;
};

/**
 * fetchRegisterSingle
 *
 * ثبت پذیرنده به صورت تکی.
 *
 * @param data اطلاعات ثبت پذیرنده
 * @returns Promise<any>
 */
export const fetchRegisterSingle = async (data: any) => {
  const response = await api.post(
    `/20card/api/pazirande/register-single`,
    data
  );
  return response.data;
};

/**
 * fetchIncreaseBalance
 *
 * افزایش موجودی یک پذیرنده.
 *
 * @param data اطلاعات تراکنش
 * @returns Promise<any>
 */
export const fetchIncreaseBalance = async (data: any) => {
  const response = await api.post(
    `/20card/api/pazirande/increase-balance`,
    data
  );
  return response.data;
};

/**
 * fetchDetailsGiftPazirande
 *
 * دریافت جزئیات هدیه‌های پذیرنده.
 *
 * @param data اطلاعات فیلتر هدیه
 * @returns Promise<any>
 */
export const fetchDetailsGiftPazirande = async (data: any) => {
  const response = await api.post(
    `/internalcredit/api/details-gift-pazirande`,
    data
  );
  return response.data;
};

/**
 * fetchChartGiftPazirande
 *
 * دریافت نمودار هدیه‌های پذیرنده.
 * TODO: نیاز به رفع خطای 422 دارد.
 *
 * @param data اطلاعات فیلتر نمودار
 * @returns Promise<any>
 */
export const fetchChartGiftPazirande = async (data: any) => {
  const response = await api.post(
    `/internalcredit/api/chart-gift-pazirande`,
    data
  );
  return response.data;
};

/**
 * fetchChartGiftPazirandeBar
 *
 * دریافت نمودار میله‌ای هدیه‌های پذیرنده.
 *
 * @param data اطلاعات فیلتر نمودار
 * @returns Promise<any>
 */
export const fetchChartGiftPazirandeBar = async (data: any) => {
  const response = await api.post(
    `/internalcredit/api/bar-chart-gift-pazirande`,
    data
  );
  return response.data;
};

/**
 * fetchListDepositWalletPazirande
 *
 * دریافت لیست تراکنش‌های واریزی کیف پول پذیرنده با فیلتر تاریخ و جستجو.
 *
 * @param data { date: string; search: string }
 * @returns Promise<any>
 */
export const fetchListDepositWalletPazirande = async (data: any) => {
  const response = await api.post(
    `20card/api/pazirande/list-deposit-wallet-pazirande?date=${data.date}&search=${data.search}`,
    data
  );
  return response.data;
};

/**
 * fetchRegisterGroup
 *
 * ثبت پذیرنده به صورت گروهی با ارسال فرم چندبخشی (multipart/form-data).
 *
 * @param data داده‌های فرم گروهی
 * @returns Promise<any>
 */
export const fetchRegisterGroup = async (data: any) => {
  const response = await api.post(
    `/20card/api/pazirande/register-group`,
    data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

/**
 * fetchCreateClub
 *
 * ایجاد کلاب جدید با فرم چندبخشی (multipart/form-data).
 *
 * @param data اطلاعات کلاب
 * @returns Promise<any>
 */
export const fetchCreateClub = async (data: any) => {
  const response = await api.post(
    `/20card/api/pazirande/create-club`,
    data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

/**
 * fetchpayment
 *
 * ثبت تراکنش پرداخت کاربر.
 *
 * @param data اطلاعات پرداخت
 * @returns Promise<any>
 */
export const fetchpayment = async (data: any) => {
  const response = await api.post(
    `/20card/api/user/payment/pay`,
    data
  );
  return response.data;
};

/**
 * fetchListWithdrawRequestPazirande
 *
 * دریافت لیست درخواست‌های برداشت پذیرنده با فیلتر تاریخ، نوع و تعداد.
 *
 * @param data { date: string; search: string; type: string; count: number }
 * @returns Promise<any>
 */
export const fetchListWithdrawRequestPazirande = async (data: any) => {
  const response = await api.post(
    `20card/api/pazirande/list-withdraw-request-pazirande?date=${data.date}&search=${data.search}&type=${data.type}&count=${data.count}`,
    data
  );
  return response.data;
};

/**
 * fetchListDepositRequestPazirande
 *
 * دریافت لیست درخواست‌های واریز پذیرنده با فیلتر تاریخ و جستجو.
 *
 * @param data { date: string; search: string }
 * @returns Promise<any>
 */
export const fetchListDepositRequestPazirande = async (data: any) => {
  const response = await api.post(
    `20card/api/pazirande/list-deposit-wallet-pazirande?date=${data.date}&search=${data.search}`,
    data
  );
  return response.data;
};

/**
 * fetchListChargeWalletPazirande2
 *
 * دریافت لیست شارژ کیف پول پذیرنده.
 *
 * @param data اختیاری
 * @returns Promise<any>
 */
export const fetchListChargeWalletPazirande2 = async (data?: any) => {
  const response = await api.post(
    `/20card/api/pazirande/list-charge-wallet-pazirande`,
    data
  );
  return response.data;
};

/**
 * fetchListRegisterWithdrawRequest
 *
 * ثبت درخواست برداشت جدید برای پذیرنده.
 *
 * @param data اختیاری
 * @returns Promise<any>
 */
export const fetchListRegisterWithdrawRequest = async (data?: any) => {
  const response = await api.post(
    `/20card/api/pazirande/register-withdraw-request`,
    data
  );
  return response.data;
};

/**
 * fetchListPazirandeDashboardChart
 *
 * دریافت داده‌های داشبورد پذیرنده به صورت نموداری.
 *
 * @param data اختیاری
 * @returns Promise<any>
 */
export const fetchListPazirandeDashboardChart = async (data?: any) => {
  const response = await api.post(
    `/20card/api/user/pazirande-dashboard-chart`,
    data
  );
  return response.data;
};

/**
 * fetchCreatePazirandeBank
 *
 * ایجاد حساب بانکی جدید برای پذیرنده.
 *
 * @param data اختیاری
 * @returns Promise<any>
 */
export const fetchCreatePazirandeBank = async (data?: any) => {
  const response = await api.post(
    `/20card/api/pazirande/create-pazirande-bank-account`,
    data
  );
  return response.data;
};


export const changeClubPazirandeUsers = async (data?: any) => {
  const response = await api.post(
    `/20card/api/pazirande/change-club-pazirande-users`,
    data
  );
  return response.data;
};
